import { ComponentType, CSSProperties, ReactNode } from 'react';

export enum SortDirection {
  asc = 'asc',
  desc = 'desc',
}

export type TableCardCellComponentProps = {
  header?: ReactNode;
  className?: string;
  colSpan?: number;
  children?: ReactNode;
};

export type TableCardRowComponentProps = {
  className?: string;
  onClick?: () => void;
  style?: CSSProperties;
  children?: ReactNode;
};

export type TableCardRowProps<T> = {
  item: T;
  cellComponent: ComponentType<TableCardCellComponentProps>;
  rowComponent: ComponentType<TableCardRowComponentProps>;
};
